import { render, staticRenderFns } from "./ShippingRequireInsuranceCheckbox.vue?vue&type=template&id=8c052e84"
import script from "./ShippingRequireInsuranceCheckbox.vue?vue&type=script&lang=js"
export * from "./ShippingRequireInsuranceCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports